import { useTranslation } from "react-i18next";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

type DeleteApartmentAlertDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	onConfirm: () => void;
	pending?: boolean;
};

export function DeleteApartmentAlertDialog({
	open,
	onOpenChange,
	onConfirm,
	pending,
}: DeleteApartmentAlertDialogProps) {
	const { t } = useTranslation();
	return (
		<AlertDialog open={open} onOpenChange={onOpenChange}>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>{t("apartments.deleteTitle")}</AlertDialogTitle>
					<AlertDialogDescription>
						{t("apartments.deleteDescription")}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>{t("apartments.cancel")}</AlertDialogCancel>
					<AlertDialogAction onClick={onConfirm} disabled={pending}>
						{t("apartments.delete")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
